import React, { ReactElement } from 'react';
import { useThemeSwitcher, ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { version } from './values';

export function useLessTheme(): [
  string | undefined,
  (mode: 'light' | 'dark' | string) => void,
  boolean
] {
  const { switcher, currentTheme, themes, status } = useThemeSwitcher();

  const setMode = (mode: 'light' | 'dark' | string) => {
    switcher({ theme: themes[mode] });
  };

  //const toggleTheme = () => setMode(currentTheme === 'light' ? 'dark' : 'light');

  return [currentTheme, setMode, status === 'loaded'];
}

// This is only used to theme CK editor
// It requires :root css vars which are [not supported/tricky/?] using CSS in JS
// Ant design does not use stylesheets and less anymore, so this is only used to cover specific circumstances
// We may use this for the report page as well...
// Dynamic themes from: https://dev.to/joserfelix/dynamic-theme-switching-in-ant-design-how-to-change-between-light-and-dark-themes-5b8p

//let defaultTheme = 'light';

export function LessThemeProvider({
  children,
  defaultTheme
}: {
  children: ReactElement;
  defaultTheme: string;
}): ReactElement {
  return (
    <ThemeSwitcherProvider
      id="tspId1"
      themeMap={{
        // Use version for cache busting
        dark: `/dark-theme.css?v=${version}`,
        light: `/light-theme.css?v=${version}`
      }}
      insertionPoint={document.getElementById('inject-theme-styles-here')}
    >
      <ThemeClassDiv>{children}</ThemeClassDiv>
      {/* {children} */}
    </ThemeSwitcherProvider>
  );
}

function ThemeClassDiv({ children }: { children: ReactElement }): ReactElement {
  const [theme] = useLessTheme();
  return <div className={`${theme}-theme`}>{children}</div>;
}
